import DateService from '../services/DateService';

export const translations = {
    gb: {
        loadMore: 'Load more',
        views: 'Views',
        likes: 'Likes',
        comments: 'Comments',
        aboutUs: 'About',
        countryCode: 'Country code (for example, DE or US)',
        subscribers: 'subscribers',
        videosNotFound: 'Couldn`t find the video for your query, try choosing a different date.',
        title: (date) => {
            const today = DateService.getTodayFormatedDate();
            const isToday = date === today;
            const dateText = isToday ? 'TODAY' : (date || 'Today');
            const dateClassName = isToday ? 'page-title__word page-title__today' : 'page-title__word';
            
            return(
                <>
                    <div className="page-title__left">
                        <span className="page-title__word"><span>G</span>lobal</span>
                        <span className="page-title__word"><span>Y</span>ouTube</span>
                        <span className="page-title__word"><span>T</span>rending</span>
                    </div>
                    <div className="page-title__right">
                        <span className={dateClassName}>{dateText}</span>
                    </div>
                </>
            );
        },
        onlyNewLabel: 'Only new',
        onlyNewTooltip: 'Show only videos that are new since yesterday',
        showAll: 'Show all',
        hide: 'Hide',
        position: 'position',
        videoTrendingToday: (country) => `This video is trending today in ${country}`,
        videoTrendingDate: (date, country) => `This video was trending on ${date} in ${country}`,
        enableGame: 'Enable Country Guess Game',
        guessCountryTitle: 'Guess the Correct Country',
        guessCountryCorrect: 'Correct! ✓',
        guessCountryIncorrect: (country) => `Incorrect. The correct answer is: ${country}`,
        close: 'Close',
        analytics: 'Analytics',
        loading: 'Loading...',
        selectGameMode: 'Select Game Mode',
        selectGameModeDescription: 'Choose how you want to play',
        singlePlayer: 'Single Player',
        singlePlayerDescription: 'Play alone and guess countries',
        multiPlayer: 'Multiplayer',
        multiPlayerDescription: 'Invite a friend and compete together',
        inviteFriend: 'Invite Friend',
        inviteFriendDescription: 'Share this link with your friend to play together',
        copyLink: 'Copy Link',
        linkCopied: 'Link copied!',
        waitingForPlayer: 'Waiting for player...',
        playerJoined: 'Player joined!',
        yourScore: 'Your Score',
        opponentScore: 'Opponent Score',
        timeLeft: 'Time Left',
        gameOver: 'Game Over',
        youWon: 'You Won! 🎉',
        youLost: 'You Lost',
        draw: "It's a Draw!",
        connecting: 'Connecting...',
        connectionError: 'Connection error. Please try again.',
        continue: 'Continue',
        aboutUsTitle: 'About Our Project',
        aboutUsDescription: `Welcome to our amazing platform! 🎉

This project was launched in response to the closure of official YouTube trends. Yes, if you didn't know, YouTube closed the "Trending" section on July 25, 2025, much to our regret.

Moreover, on YouTube, trends have always been localized by country, and it was not possible to see which video is trending today in most countries. That is, you had to switch between different countries and watch the trends of each country separately.

Therefore, the idea was born to create a YouTube trends aggregator for all countries where YouTube is represented. The main ranking factor for videos is the number of countries where this video is trending today. 📊`,

        aboutUsSection1Title: 'Our Mission 🎯',
        aboutUsSection1Text: `Our mission is to clearly show which video is trending today and in what position it is in each country! 🌟

        For each video, you can track the growth dynamics of its metrics (Views, Likes, Comments) while it is trending.

We also have a small gamification element. Test your geography knowledge 🧠! On the first video in the list, there is a "Guess the Country by Flag" game. You can play with friends or alone. 🎮

Join us on this exciting journey! 🚀`,

        aboutUsSection2Title: 'Where Do We Get Information? ✨',
        aboutUsSection2Text: `Every day we make requests to the YouTube API for each country and perform data aggregation. 📡

You can read more about the API in the official YouTube documentation: https://developers.google.com/youtube/v3/docs/videos/list 📚`,

        aboutUsSection3Title: 'Technologies Used in the Project 💎',
        aboutUsSection3Text: `Our technology stack: 💻

• Backend: PHP, Symfony, PostgreSQL 🗄️
• Frontend: React ⚛️
• Team lead: Cursor AI 

More details on our GitHub (It will be a little later)! 🔗`,
        projectIdeaTitle: 'Idea & Inspiration Behind the Project',
        projectIdeaDescription: 'This project was born from a clear vision and a passion for transforming YouTube data and analytics into meaningful, engaging video insights.',
        projectIdeaAuthor: 'Alexandr Stepanov',
        metaTitle: (formattedDate) => {
            const dateStr = formattedDate || 'today';
            if (dateStr === 'today' || dateStr.toLowerCase() === 'today') {
                return 'Global YouTube Trending TODAY - Watch Top Trending Videos';
            }
            return `Global YouTube Trending - ${dateStr} | Top Trending Videos`;
        },
        metaDescription: (formattedDate) => {
            const dateStr = formattedDate || 'today';
            if (dateStr === 'today' || dateStr.toLowerCase() === 'today') {
                return 'Discover the most trending YouTube videos today from around the world. See which videos are trending globally and track their statistics.';
            }
            return `View the most trending YouTube videos from ${dateStr}. Discover global YouTube trends and track video statistics including views, likes, and comments.`;
        }
    },
    ru: {
        loadMore: "Загрузить еще",
        views: 'Просмотры',
        likes: 'Лайки',
        comments: 'Комментарии',
        aboutUs: 'О проекте',
        countryCode: 'Код страны (например, DE или US)',
        subscribers: 'подписчиков',
        videosNotFound: 'Не удалось найти видео по вашему запросу, попробуйте выбрать другую дату',
        title: (date) => {
            const today = DateService.getTodayFormatedDate();
            const isToday = date === today;
            const dateText = isToday ? 'Сегодня' : (date || 'Сегодня');
            const dateClassName = isToday ? 'page-title__word page-title__today' : 'page-title__word';
            
            return(
                <>
                    <div className="page-title__left">
                        <span className="page-title__word"><span>Г</span>лобальные</span>
                        <span className="page-title__word"><span>Y</span>outube</span>
                        <span className="page-title__word"><span>Т</span>ренды</span>
                        
                    </div>
                    <div className="page-title__right">
                        <span className={dateClassName}>{dateText}</span>
                    </div>
                </>
            );
        },
        onlyNewLabel: 'Только новые',
        onlyNewTooltip: 'Показывать только новые видео со вчера',
        showAll: 'Показать все',
        hide: 'Скрыть',
        position: 'позиция',
        videoTrendingToday: (country) => `Это видео сегодня в трендах в ${country}`,
        videoTrendingDate: (date, country) => `Это видео было ${date} в трендах ${country}`,
        enableGame: 'Включить игру "Угадай страну"',
        guessCountryTitle: 'Угадайте правильную страну',
        guessCountryCorrect: 'Правильно! ✓',
        guessCountryIncorrect: (country) => `Неправильно. Правильный ответ: ${country}`,
        close: 'Закрыть',
        analytics: 'Аналитика',
        loading: 'Загрузка...',
        selectGameMode: 'Выберите режим игры',
        selectGameModeDescription: 'Выберите, как вы хотите играть',
        singlePlayer: 'Одиночная игра',
        singlePlayerDescription: 'Играйте в одиночку и угадывайте страны',
        multiPlayer: 'Мультиплеер',
        multiPlayerDescription: 'Пригласите друга и соревнуйтесь вместе',
        inviteFriend: 'Пригласить друга',
        inviteFriendDescription: 'Поделитесь этой ссылкой с другом, чтобы играть вместе',
        copyLink: 'Скопировать ссылку',
        linkCopied: 'Ссылка скопирована!',
        waitingForPlayer: 'Ожидание игрока...',
        playerJoined: 'Игрок присоединился!',
        yourScore: 'Ваш счет',
        opponentScore: 'Счет соперника',
        timeLeft: 'Осталось времени',
        gameOver: 'Игра окончена',
        youWon: 'Вы выиграли! 🎉',
        youLost: 'Вы проиграли',
        draw: 'Ничья!',
        connecting: 'Подключение...',
        connectionError: 'Ошибка подключения. Попробуйте еще раз.',
        continue: 'Продолжить',
        aboutUsTitle: 'О нашем проекте',
        // Пример 1: Многострочный текст с шаблонными строками (обратные кавычки `)
        // Это самый удобный способ для больших текстов с переносами строк
        aboutUsDescription: `Добро пожаловать на нашу удивительную платформу! 🎉

Этот проект был запущен в ответ на закрытие официальных трендов YouTube. Да, если вы не знали, но YouTube закрыл раздел «В тренде» 25 июля 2025 года, к великому сожалению. 

Более того, на YouTube тренды всегда были локализованы по странам, и увидеть, какое видео сегодня в трендах в большинстве стран, не представлялось возможным. То есть нужно было переключаться на различные страны и смотреть тренды каждой страны отдельно.

Поэтому родилась идея создать агрегатор трендов YouTube по всем странам, где представлен YouTube. Главный фактор ранжирования роликов — это количество стран, где это видео сегодня в трендах. 📊`,

        aboutUsSection1Title: 'Наша миссия 🎯',
        // Пример 2: Большой текст с несколькими абзацами и эмодзи
        aboutUsSection1Text: `Наша миссия — наглядно показать, какое видео сегодня в трендах и на каком месте оно находится в каждой стране! 🌟

        По каждому видео можно отследить динамику прироста показателей(Просмотры, лайки, комментарии), пока оно находится в трендах.

Также у нас есть небольшой элемент геймификации. Проверь свои знания 🧠 географии! На каждом первом видео в списке есть игра «Угадай страну по флагу». Можно играть с друзьями или одному. 🎮

Присоединяйтесь к нам в этом увлекательном путешествии! 🚀`,

        aboutUsSection2Title: 'Откуда мы берем информацию? ✨',
        // Пример 3: Текст с форматированием и списком (используя переносы строк)
        aboutUsSection2Text: `Каждый день мы делаем запросы к API YouTube по каждой стране и выполняем агрегацию данных. 📡

Подробнее про API можете почитать в официальной документации YouTube: https://developers.google.com/youtube/v3/docs/videos/list 📚`,

        aboutUsSection3Title: 'Технологии используемые в проекте 💎',
        // Пример 4: Еще один пример большого текста
        aboutUsSection3Text: `Наш технологический стек: 💻

• Backend: PHP, Symfony, PostgreSQL 🗄️
• Frontend: React ⚛️
• Team lead: Cursor AI

Подробнее на нашем GitHub (будет чуть позже)! 🔗`,
        projectIdeaTitle: 'Идея и вдохновение проекта',
        projectIdeaDescription: 'Этот проект родился из четкого видения и страсти к преобразованию данных и аналитики YouTube в значимые и увлекательные видеоинсайты.',
        projectIdeaAuthor: 'Александр Степанов',
        metaTitle: (formattedDate) => {
            const dateStr = formattedDate || 'сегодня';
            if (dateStr === 'сегодня' || dateStr.toLowerCase() === 'сегодня') {
                return 'Глобальные тренды YouTube сегодня - Смотрите топ трендовых видео';
            }
            return `Глобальные тренды YouTube - ${dateStr} | Топ трендовых видео`;
        },
        metaDescription: (formattedDate) => {
            const dateStr = formattedDate || 'сегодня';
            if (dateStr === 'сегодня' || dateStr.toLowerCase() === 'сегодня') {
                return 'Откройте для себя самые трендовые видео YouTube сегодня со всего мира. Узнайте, какие видео в трендах глобально и отслеживайте их статистику.';
            }
            return `Просмотрите самые трендовые видео YouTube от ${dateStr}. Откройте для себя глобальные тренды YouTube и отслеживайте статистику видео, включая просмотры, лайки и комментарии.`;
        }
    },
};
